import { translations } from './translations';

// constants.ts

// Define interfaces for better type checking
export interface Translation {
  en: string;
  am: string;
}

export interface SubCategory extends Translation {}

export interface Category extends Translation {
  subcategories: { [key: string]: SubCategory };
}

// The item subcategories constant
export const ITEM_SUBCATEGORIES: { [key: string]: Category } = {
  'phone-tablets': {
    en: 'Phones & Tablets',
    am: 'ስልኮች እና ታብሌቶች',
    subcategories: {
      smartphones: { en: 'Smartphones', am: 'ስማርትፎኖች' },
      feature_phones: { en: 'Feature Phones', am: 'ታጣፊ እና የመረጃ ስልኮች' },
      tablets: { en: 'Tablets', am: 'ታብሌቶች' },
      smartwatches: { en: 'Smartwatches', am: 'ስማርት ዎች' },
      accessories: { en: 'Accessories', am: 'ተጨማሪ እቃዎች' },
      power_banks: { en: 'Power Banks', am: 'የኃይል ባንኮች' },
    },
  },
  'electronics': {
    en: 'Electronics',
    am: 'ኤሌክትሮኒክስ',
    subcategories: {
      televisions: { en: 'Televisions', am: 'ቲቪዎች' },
      audio_systems: { en: 'Audio Systems', am: 'የድምጽ ሲስተም' },
      cameras: { en: 'Cameras & Photography', am: 'ካሜራዎች እና ፎቶግራፊ' },
      gaming_consoles: { en: 'Gaming Consoles', am: 'የጌም ኮንሶሎች' },
      home_appliances: { en: 'Home Appliances', am: 'የቤት እና ኪችን እቃዎች' },
      laptops: { en: 'Laptops & Accessories', am: 'ላፕቶፖች እና ቻርጀሮች' },
      smart_home: { en: 'Smart Home Devices', am: 'የስማርት ቤት መሳሪያዎች' },
    },
  },
  'clothing': {
    en: 'Clothing & Shoes',
    am: 'ልብስ እና ጫማ',
    subcategories: {
      mens_clothing: { en: "Men's Clothing", am: 'የወንዶች ልብስ' },
      womens_clothing: { en: "Women's Clothing", am: 'የሴቶች ልብስ' },
      kids_clothing: { en: "Kids' Clothing", am: 'የልጆች ልብስ' },
      footwear: { en: 'Footwear', am: 'ጫማ' },
      accessories: { en: 'Accessories', am: 'ሌሎች ማጌጫዎች' },
      traditional_wear: { en: 'Traditional Wear', am: 'የባህል ልብስ' },
    },
  },
  'health': {
    en: 'Health & Beauty',
    am: 'የጤና እና የውበት እቃ',
    subcategories: {
      skincare: { en: 'Skincare', am: 'የቆዳ እንክብካቤ' },
      makeup: { en: 'Makeup & Cosmetics', am: 'ሜካፕ እና ኮስሜቲክስ' },
      haircare: { en: 'Haircare Products', am: 'የጸጉር እንክብካቤ' },
      fragrances: { en: 'Perfumes & Fragrances', am: 'ሽቶዎች' },
      supplements: { en: 'Health Supplements', am: 'የጤና መጠበቂያዎች' },
      personal_care: { en: 'Personal Care', am: 'የግል እንክብካቤ' },
      medical_equipment: { en: 'Medical Equipment', am: 'የሕክምና መሳሪያዎች' },
    },
  },
  'home-garden': {
    en: 'Home & Garden',
    am: 'የቤት እና የመስሪያ ቤት እቃ',
    subcategories: {
      furniture: { en: 'Furniture', am: 'የቤት ዉስጥ እቃዎች' },
      kitchenware: { en: 'Kitchenware', am: 'የምግብ መስሪያ እና ማቅረቢያ' },
      home_decor: { en: 'Home Decor', am: 'የቤት ማስዋቢያ' },
      bedding_mattresses: { en: 'Bedding & Mattresses', am: 'የመኝታ እቃዎች' },
      lighting_fixtures: { en: 'Lighting & Fixtures', am: 'መብራት እና ቁሳቁሶች' },
      gardening_tools: { en: 'Gardening Tools', am: 'የአትክልት መሣሪያዎች' },
      cleaning_supplies: { en: 'Cleaning Supplies', am: 'የጽዳት እቃዎች' },
    },
  },
  'sports': {
    en: 'Sports & Outdoors',
    am: 'የስፖርት እና የመዝናኛ እቃ',
    subcategories: {
      gym_equipment: { en: 'Gym Equipment', am: 'የጂም መሣሪያዎች' },
      sportswear: { en: 'Sportswear', am: 'የስፖርት ልብስ' },
      outdoor_camping_gear: { en: 'Outdoor & Camping Gear', am: 'የውጪ እና የካምፒንግ መሣሪያዎች' },
      bicycles_accessories: { en: 'Bicycles & Accessories', am: 'ሳይክሎች እና ተጨማሪ እቃዎች' },
      football_basketball_equipment: { en: 'Football & Basketball Equipment', am: 'የእግር ኳስ እና ባስክትቦል መሣሪያዎች' },
      fishing_hunting_gear: { en: 'Fishing & Hunting Gear', am: 'የአሳ ማጥመጃ መሣሪያዎች' },
    },
  },
  'toys': {
    en: 'Toys & Games',
    am: 'አሻንጉሊቶች እና መጫዋቻዎች',
    subcategories: {
      educational_toys: { en: 'Educational Toys', am: 'ትምህርት የሚሰጡ አሻንጉሊቶች' },
      action_figures: { en: 'Action Figures', am: 'አክሽን ፊገርስ' },
      dolls_stuffed_toys: { en: 'Dolls & Toys', am: 'አሻንጉሊቶች' },
      board_games: { en: 'Board Games', am: 'የቦርድ ጨዋታዎች' },
      video_games_consoles: { en: 'Video Games & Consoles', am: 'ቪዲዮ ጨዋታዎች እና ኮንሶሎች' },
    },
  },
  'books': {
    en: 'Books',
    am: 'መጽሐፍት እና የጽህፈት መሳሪያ',
    subcategories: {
      fiction_books: { en: 'Fiction Books', am: 'የልብወለድ መጽሐፍት' },
      non_fiction_books: { en: 'Non-Fiction Books', am: 'የታሪክ መጽሐፍት' },
      educational_books: { en: 'Educational Books', am: 'የትምህርት መጽሐፍት' },
      childrens_books: { en: "Children's Books", am: 'የልጆች መጽሐፍት' },
      magazines: { en: 'Magazines', am: 'ማጋዚኖች' },
      stationery_office: { en: 'Stationery & Office Supplies', am: 'የጽህፈት እቃዎች እና የቢሮ እቃዎች' },
    },
  },
  'food': {
    en: 'Food',
    am: 'ምግቦች',
    subcategories: {
      snacks_beverages: { en: 'Snacks & Beverages', am: 'ስናክ እና መጠጦች' },
      fresh_produce: { en: 'Fresh Food', am: 'ተፈጥሮዊ ምግቦች' },
      dairy_products: { en: 'Dairy Products', am: 'የወተት ምርቶች' },
      meat_seafood: { en: 'Meat & Seafood', am: 'ስጋ እና አሳ ምግቦች' },
      grains_cereals: { en: 'Grains & Cereals', am: 'እህል እና ዱቄት' },
      cooking_ingredients: { en: 'Cooking Ingredients', am: 'የምግብ ተዋጽዎች' },
      packaged_foods: { en: 'Packaged Foods', am: 'የታሸጉ ምግቦች' },
    },
  },
  'industrial-equipment': {
    en: 'Industrial and Construction Equipment',
    am: 'የኢንዱስትሪ እና የግንባታ እቃ',
    subcategories: {
      heavy_machinery: { en: 'Heavy Machinery', am: 'ከባድ ማሽነሪያዎች' },
      power_tools: { en: 'Power Tools', am: 'የስራ መሣሪያዎች' },
      safety_equipment: { en: 'Safety Equipment', am: 'የደህንነት መሣሪያዎች' },
      electrical_equipment: { en: 'Electrical Equipment', am: 'ኤሌክትሪክ መሣሪያዎች' },
      plumbing_supplies: { en: 'Plumbing Supplies', am: 'የፕላሚንግ እቃዎች' },
      welding_tools: { en: 'Welding Tools', am: 'የዊልዲንግ መሣሪያዎች' },
      construction_materials: { en: 'Construction Materials', am: 'የግንባታ እቃዎች' },
    },
  },
  'vehicles and spairs': {
    en: 'Vehicles',
    am: 'ተሽከርካሪዎች እና ፓርቶች',
    subcategories: {
      cars: { en: 'Cars', am: 'መኪኖች' },
      motorcycles: { en: 'Motorcycles', am: 'ሞተርሳይክሎች' },
      auto_parts: { en: 'Auto Spare Parts', am: 'የመኪና ፓርቶች' },
      car_accessories: { en: 'Car Accessories', am: 'የመኪና ተጨማሪ እቃዎች' },
      batteries_tires: { en: 'Batteries & Tires', am: 'ባትሪዎች እና ጎማዎች' },
      trucks_buses: { en: 'Trucks & Buses', am: 'ትራክ እና ባስ' },
    },
  },
  'property': {
    en: 'Property',
    am: 'ቤት እና ንብረት',
    subcategories: {
      residential: { en: 'Residential Properties', am: 'የመኖሪያ ቤቶች' },
      commercial: { en: 'Commercial Properties', am: 'የንግድ ቦታዎች' },
      land: { en: 'Land', am: 'መሬት' },
      rentals: { en: 'Rental Properties', am: 'የኪራይ ቤቶች' },
      offices: { en: 'Office Spaces', am: 'የመስሪያ ቤቶች' },
      hotels: { en: 'Hotels & Resorts', am: 'ሆቴሎች እና የእረፍት ቦታዎች' },
    },
  },
};

// Helper function to get translated item categories
export function getTranslatedItemCategories(lang: keyof Translation = 'en'): { [key: string]: string } {
  return Object.keys(ITEM_SUBCATEGORIES).reduce((acc, categoryKey) => {
    const category = ITEM_SUBCATEGORIES[categoryKey];
    // Fallback to English if the requested language is not available
    acc[categoryKey] = category[lang] || category.en;
    return acc;
  }, {} as { [key: string]: string });
}

// Helper function to get translated subcategories for a specific category
export function getTranslatedItemSubcategories(
  categoryKey: string,
  lang: keyof Translation = 'en'
): { [key: string]: string } {
  const category = ITEM_SUBCATEGORIES[categoryKey];
  if (!category) return {};

  return Object.keys(category.subcategories).reduce((acc, subCatKey) => {
    const subCat = category.subcategories[subCatKey];
    acc[subCatKey] = subCat[lang] || subCat.en;
    return acc;
  }, {} as { [key: string]: string });
}


export const countryCodes = [
  { code: '+251', name: 'Ethiopia' },
  { code: '+1', name: 'USA/Canada' },
  { code: '+44', name: 'UK' },
  { code: '+33', name: 'France' },
  { code: '+49', name: 'Germany' },
  { code: '+972', name: 'Israel' },
  { code: '+966', name: 'Saudi Arabia' },
  { code: '+971', name: 'United Arab Emirates' },
  { code: '+61', name: 'Australia' },
  { code: '+46', name: 'Sweden' },
  { code: '+39', name: 'Italy' },
  { code: '+31', name: 'Netherlands' },
  { code: '+47', name: 'Norway' },
  { code: '+45', name: 'Denmark' },
  { code: '+34', name: 'Spain' },
  { code: '+41', name: 'Switzerland' },
  { code: '+64', name: 'New Zealand' },
  { code: '+32', name: 'Belgium' },
  { code: '+358', name: 'Finland' },
  { code: '+86', name: 'China' },
  { code: '+91', name: 'India' },
  { code: '+254', name: 'Kenya' },
  { code: '+27', name: 'South Africa' },
  { code: '+256', name: 'Uganda' },
  { code: '+234', name: 'Nigeria' },
  { code: '+20', name: 'Egypt' },
  { code: '+82', name: 'South Korea' },
];

// Database values (English versions)
export const DB_CITIES = [
  'Addis Ababa', 'Dire Dawa', 'Mekelle', 'Gondar', 'Bahir Dar',
  'Hawassa', 'Adama', 'Jimma', 'Dessie', 'Bishoftu',
  'Jijiga', 'Shashamane', 'Wolaita Sodo', 'Arba Minch', 'Harar',
  'Debre Markos', 'Debre Birhan', 'Asella', 'Ambo', 'Nekemte'
];

// Item Categories
export const ITEM_CATEGORIES = {
  'phone-tablets': { en: 'Phones & Tablets', am: 'ስልኮች እና ታብሌቶች' },
  'electronics': { en: 'Electronics', am: 'ኤሌክትሮኒክስ' },
  'clothing': { en: 'Clothing and Shoes', am: 'ልብስ እና ጫማ' },
  'health': { en: 'Health & Beauty', am: 'የጤና እና የውበት እቃ' },
  'home-garden': { en: 'Home & Garden', am: 'የቤት እና የመስሪያ ቤት እቃ' },
  'sports': { en: 'Sports & Outdoors', am: 'የስፖርት እና የመዝናኛ እቃ' },
  'toys': { en: 'Toys & Games', am: 'አሻንጉሊቶች እና መጫዋቻዎች' },
  'books': { en: 'Books', am: 'መጽሐፍት እና የጽህፈት መሳሪያ' },
  'food': { en: 'Food', am: 'ምግቦች' },
  'industrial-equipment': { en: 'Industrial and Construction Equipment', am: 'የኢንዱስትሪ እና የግንባታ እቃ' },
  'vehicles and spairs': { en: 'Vehicles', am: 'ተሽከርካሪዎች እና ፓርቶች' },
  'property': { en: 'Property', am: 'ቤት እና ንብረት' },
};

// Day translations
export const DAYS_OF_WEEK = {
  sun: { en: 'Sunday', am: 'እሁድ' },
  mon: { en: 'Monday', am: 'ሰኞ' },
  tue: { en: 'Tuesday', am: 'ማክሰኞ' },
  wed: { en: 'Wednesday', am: 'ረቡዕ' },
  thu: { en: 'Thursday', am: 'ሐሙስ' },
  fri: { en: 'Friday', am: 'አርብ' },
  sat: { en: 'Saturday', am: 'ቅዳሜ' }
};

export const ABBREVIATED_DAYS = {
  sun: { en: 'Sun', am: 'እሁድ' },
  mon: { en: 'Mon', am: 'ሰኞ' },
  tue: { en: 'Tue', am: 'ማክሰ' },
  wed: { en: 'Wed', am: 'ረቡዕ' },
  thu: { en: 'Thu', am: 'ሐሙስ' },
  fri: { en: 'Fri', am: 'አርብ' },
  sat: { en: 'Sat', am: 'ቅዳሜ' }
};

// Helper function to get translated day name
export const getDayName = (dayKey: keyof typeof DAYS_OF_WEEK, language: keyof Translation = 'en', abbreviated: boolean = false): string => {
  const daysMap = abbreviated ? ABBREVIATED_DAYS : DAYS_OF_WEEK;
  return daysMap[dayKey]?.[language] || daysMap[dayKey]?.en || dayKey;
};

// Item Conditions
export const ITEM_CONDITIONS = {
  'new': { en: 'New', am: 'አዲስ' },
  'used': { en: 'Used', am: 'ያገለገለ' }
};

// City translations
const CITY_TRANSLATIONS = {
  'Addis Ababa': { en: 'Addis Ababa', am: 'አዲስ አበባ' },
  'Dire Dawa': { en: 'Dire Dawa', am: 'ድሬዳዋ' },
  'Mekelle': { en: 'Mekelle', am: 'መቀሌ' },
  'Gondar': { en: 'Gondar', am: 'ጎንደር' },
  'Bahir Dar': { en: 'Bahir Dar', am: 'ባህር ዳር' },
  'Hawassa': { en: 'Hawassa', am: 'ሐዋሳ' },
  'Adama': { en: 'Adama', am: 'አዳማ' },
  'Jimma': { en: 'Jimma', am: 'ጅማ' },
  'Dessie': { en: 'Dessie', am: 'ደሴ' },
  'Kombolcha': { en: 'Kombolcha', am: 'ኮምቦልቻ' },
  'Bishoftu': { en: 'Bishoftu', am: 'ቢሾፍቱ' },
  'Jijiga': { en: 'Jijiga', am: 'ጅጅጋ' },
  'Shashamane': { en: 'Shashamane', am: 'ሻሸመኔ' },
  'Wolaita Sodo': { en: 'Wolaita Sodo', am: 'ወላይታ ሶዶ' },
  'Arba Minch': { en: 'Arba Minch', am: 'አርባ ምንጭ' },
  'Harar': { en: 'Harar', am: 'ሐረር' },
  'Debre Markos': { en: 'Debre Markos', am: 'ደብረ ማርቆስ' },
  'Debre Birhan': { en: 'Debre Birhan', am: 'ደብረ ብርሃን' },
  'Asella': { en: 'Asella', am: 'አሰላ' },
  'Ambo': { en: 'Ambo', am: 'አምቦ' },
  'Nekemte': { en: 'Nekemte', am: 'ነቀምት' }
};

// Category translations
// Category translations
const CATEGORY_TRANSLATIONS = {
  'home-services': { en: 'Home Services', am: 'የቤት አገልግሎቶች' },
  'technical-repair': { en: 'Technical Repair', am: 'ቴክኒካል ጥገና' },
  'personal-services': { en: 'Personal Services', am: 'የግል አገልግሎቶች' },
  'creative-services': { en: 'Creative Services', am: 'የፈጠራ አገልግሎቶች' },
  'professional-services': { en: 'Professional Services', am: 'ሙያዊ አገልግሎቶች' },
  'food-hospitality': { en: 'Food & Hospitality', am: 'ምግብ እና እንግዳ ተቀባይነት' },
  'delivery-services': { en: 'Delivery Services', am: 'የማድረስ አገልግሎቶች' },
  'craftsmanship-services': { en: 'Craftsmanship Services', am: 'የእጅ ብረት እና እንጨት ስራዎች' }
};

export const DB_SERVICES = {
  'home-services': [
    'Cleaning', 'Lawn Care & Landscaping',
    'Pest Control', 'Handyman Services', 'Plumbing', 'HVAC Services',
    'Window Washing', 'Carpet Cleaning', 'Moving & Packing', 'Pool Maintenance',
    'Home Organization', 'Interior & Exterior Planning', 'Gutter Cleaning',
    'Roof Repair', 'Window Installation', 'Flooring'
  ],
  'technical-repair': [
    'Electrical Installation', 'Appliance Repair', 'Computer & IT Support',
    'Phone Repair', 'Home Security Installation', 'Auto Repair', 'Locksmith Services',
    'Electronics Repair'
  ],
  'personal-services': [
    'Hair Styling & Barbering', 'Nail Care & Pedicure', 'Makeup Artistry', 'Pet Sitting & Dog Walking',
    'Childcare / Babysitting', 'Elderly Care', 'Personal Shopping', 'Wardrobe Consulting',
    'Personal Chef', 'Yoga Instruction', 'Meditation Coaching', 'Tutoring', 'Personal Training', 'Massage Therapy'
  ],
  'creative-services': [
    'Photography', 'Videography', 'Graphic Design', 'Web Design & Development',
    'Writing & Editing', 'Event Planning', 'Music Lessons', 'Art Classes',
    'Animation Services', 'Voice Over Services', 'Podcast Production',
    'Fashion Design'
  ],
  'professional-services': [
    'Accounting & Bookkeeping', 'Tax Preparation', 'Legal Consulting',
    'Business Consulting', 'Marketing & Social Media',
    'Translation Services', 'Career Coaching', 'Life Coaching', 'Real Estate Consulting',
    'Financial Planning', 'Human Resources Consulting', 'Project Management', 'IT Consulting'
  ],
  'food-hospitality': [
    'Catering','Bartending Services', 'Wedding Planning',
    'Food Truck Services', 'Barista Services'
  ],
  'delivery-services': [
    'Food Delivery', 'Retail Delivery',
    'Courier Services', 'Packing & Shipping'
  ],
  'craftsmanship-services': [
    'Woodworking', 'Metalworking', 'CNC Machining', 'Laser Cutting',
    '3D Printing', 'Cabinet Making',
    'Jewelry Making', 'Pottery',
    'Leatherworking', 'Stone Carving', 'Ceramics', 'Textile Design'
  ]
};

const SERVICE_TRANSLATIONS = {
  // Home Services
  'Cleaning': { en: 'Cleaning', am: 'ጽዳት' },
  'Lawn Care & Landscaping': { en: 'Lawn Care & Landscaping', am: 'የእትክልት ስፍራ እንክብካቤ' },
  'Pest Control': { en: 'Pest Control', am: 'የጎጂ ነፍሳት ቁጥጥር' },
  'Handyman Services': { en: 'Handyman Services', am: 'የጥገና አገልግሎት' },
  'Plumbing': { en: 'Plumbing', am: 'የውሃ መስመር ጥገና' },
  'HVAC Services': { en: 'HVAC Services', am: 'የማቀዝቀዣ እና ማሞቂያ አገልግሎት' },
  'Window Washing': { en: 'Window Washing', am: 'የመስኮት ጽዳት' },
  'Carpet Cleaning': { en: 'Carpet Cleaning', am: 'የምንጣፍ ጽዳት' },
  'Moving & Packing': { en: 'Moving & Packing', am: 'የእቃ ማጓጓዝ' },
  'Pool Maintenance': { en: 'Pool Maintenance', am: 'የዋና ገንዳ እንክብካቤ' },
  'Home Organization': { en: 'Home Organization', am: 'ቤት ማስተካከል' },
  'Interior & Exterior Planning': { en: 'Interior & Exterior Planning', am: 'የውስጥ እና የውጭ ማስዋብ' },
  'Gutter Cleaning': { en: 'Gutter Cleaning', am: 'የቆሻሻ ቧንቧ ጽዳት' },
  'Roof Repair': { en: 'Roof Repair', am: 'የጣራ ጥገና' },
  'Window Installation': { en: 'Window Installation', am: 'የመስኮት ስራ' },
  'Flooring': { en: 'Flooring', am: 'የወለል ማንጠፍ ስራ' },

  // Technical Repair
  'Electrical Installation': { en: 'Electrical Installation', am: 'የኤሌክትሪክ መስመር ዝርጋታ' },
  'Appliance Repair': { en: 'Appliance Repair', am: 'የቤት እቃ ጥገና' },
  'Computer & IT Support': { en: 'Computer & IT Support', am: 'የኮምፒዩተር እና IT ድጋፍ' },
  'Phone Repair': { en: 'Phone Repair', am: 'የሞባይል ስልክ ጥገና' },
  'Home Security Installation': { en: 'Home Security Installation', am: 'የቤት ደህንነት ዝርጋታ' },
  'Auto Repair': { en: 'Auto Repair', am: 'የመኪና ጥገና' },
  'Locksmith Services': { en: 'Locksmith Services', am: 'የቁልፍ ስራ አገልግሎት' },
  'Electronics Repair': { en: 'Electronics Repair', am: 'የኤሌክትሮኒክስ ጥገና' },

  // Personal Services
  'Hair Styling & Barbering': { en: 'Hair Styling & Barbering', am: 'የሴት እና የወንድ ፀጉር ስራ' },
  'Nail Care & Pedicure': { en: 'Nail Care & Pedicure', am: 'የእጅ እና የእግር ጥፍር ስራ' },
  'Makeup Artistry': { en: 'Makeup Artistry', am: 'የሜካፕ ስራ' },
  'Pet Sitting & Dog Walking': { en: 'Pet Sitting & Dog Walking', am: 'የቤት እንስሳ እንክብካቤ' },
  'Childcare / Babysitting': { en: 'Childcare / Babysitting', am: 'የልጆች እንክብካቤ' },
  'Elderly Care': { en: 'Elderly Care', am: 'የአዛዉንት እንክብካቤ' },
  'Personal Shopping': { en: 'Personal Shopping', am: 'የግል እቃ ግዢ' },
  'Wardrobe Consulting': { en: 'Wardrobe Consulting', am: 'የአልባሳት ምክር' },
  'Personal Chef': { en: 'Personal Chef', am: 'የግል ምግብ ሰሪ' },
  'Yoga Instruction': { en: 'Yoga Instruction', am: 'የዮጋ ትምህርት' },
  'Meditation Coaching': { en: 'Meditation Coaching', am: 'የMeditation አገልግሎት' },
  'Tutoring': { en: 'Tutoring', am: 'የግል አስተማሪ' },
  'Personal Training': { en: 'Personal Training', am: 'የግል አሰልጣኝ' },
  'Massage Therapy': { en: 'Massage Therapy', am: 'የማሳጅ አገልግሎት' },

  // Creative Services
  'Photography': { en: 'Photography', am: 'ፎቶግራፊ' },
  'Videography': { en: 'Videography', am: 'ቪዲዮግራፊ' },
  'Graphic Design': { en: 'Graphic Design', am: 'ግራፊክ ዲዛይን' },
  'Web Design & Development': { en: 'Web Design & Development', am: 'የዌብ ዲዛይን' },
  'Writing & Editing': { en: 'Writing & Editing', am: 'የጽሁፍ ስራ' },
  'Event Planning': { en: 'Event Planning', am: 'የድግስ ዝግጅት' },
  'Music Lessons': { en: 'Music Lessons', am: 'የሙዚቃ ትምህርት' },
  'Art Classes': { en: 'Art Classes', am: 'የስነ ጥበብ ትምህርት' },
  'Animation Services': { en: 'Animation Services', am: 'አኒሜሽን አገልግሎቶች' },
  'Voice Over Services': { en: 'Voice Over Services', am: 'የድምፅ አገልግሎት' },
  'Podcast Production': { en: 'Podcast Production', am: 'ፖድካስት ስራ' },
  'Fashion Design': { en: 'Fashion Design', am: 'የፋሽን ዲዛይን' },

  // Professional Services
  'Accounting & Bookkeeping': { en: 'Accounting & Bookkeeping', am: 'የመዛግብት ማስተካከያ' },
  'Tax Preparation': { en: 'Tax Preparation', am: 'የታክስ ቅንብር' },
  'Legal Consulting': { en: 'Legal Consulting', am: 'የህግ አማካሪ' },
  'Business Consulting': { en: 'Business Consulting', am: 'የንግድ ምክር' },
  'Marketing & Social Media': { en: 'Marketing & Social Media', am: 'የሶሻል ሚዲያ ማርከቲንግ' },
  'Translation Services': { en: 'Translation Services', am: 'የትርጉም አገልግሎት' },
  'Career Coaching': { en: 'Career Coaching', am: 'የሥራ ምክር' },
  'Life Coaching': { en: 'Life Coaching', am: 'የሕይወት ምክር' },
  'Real Estate Consulting': { en: 'Real Estate Consulting', am: 'የንብረት ገዥ ምክር' },
  'Financial Planning': { en: 'Financial Planning', am: 'የፋይናንስ ፕላን' },
  'Human Resources Consulting': { en: 'Human Resources Consulting', am: 'የሰራተኛ ቅጥር ምክር' },
  'Project Management': { en: 'Project Management', am: 'የፕሮጀክት ማነጅመንት' },
  'IT Consulting': { en: 'IT Consulting', am: 'የአይሲቲ ምክር' },

  // Food & Hospitality
  'Catering': { en: 'Catering', am: 'የምግብ ዝግጅት' },
  'Bartending Services': { en: 'Bartending Services', am: 'የባር አገልግሎቶች' },
  'Wedding Planning': { en: 'Wedding Planning', am: 'የሰርግ ዝግጅት' },
  'Food Truck Services': { en: 'Food Truck Services', am: 'የምግብ ተሽከርካሪ' },
  'Barista Services': { en: 'Barista Services', am: 'የባሪስታ አገልግሎቶች' },

  // Delivery Services
  'Food Delivery': { en: 'Food Delivery', am: 'ምግብ ማድረስ' },
  'Retail Delivery': { en: 'Retail Delivery', am: 'የንግድ ምርት ማድረስ' },
  'Courier Services': { en: 'Courier Services', am: 'የማድረስ አገልግሎት' },
  'Packing & Shipping': { en: 'Packing & Shipping', am: 'የማሸግ እና ሺፒንግ አገልግሎቶች' },

  // Craftsmanship Services
  'Woodworking': { en: 'Woodworking', am: 'የእንጨት ስራ' },
  'Metalworking': { en: 'Metalworking', am: 'የብረት ስራ' },
  'CNC Machining': { en: 'CNC Machining', am: 'CNC ማሽን ስራዎች' },
  'Laser Cutting': { en: 'Laser Cutting', am: 'የላዘር መቁረጥ ስራ' },
  '3D Printing': { en: '3D Printing', am: 'የ3d Print ስራ' },
  'Cabinet Making': { en: 'Cabinet Making', am: 'የካቢነት መግጠም ስራ' },
  'Jewelry Making': { en: 'Jewelry Making', am: 'የጌጣጌጦች ስራ' },
  'Pottery': { en: 'Pottery', am: 'የሽክላ ስራ' },
  'Leatherworking': { en: 'Leatherworking', am: 'የቆዳ ስራ' },
  'Stone Carving': { en: 'Stone Carving', am: 'የድንጋይ ቅርፅ ስራ' },
  'Ceramics': { en: 'Ceramics', am: 'የሴራሚክ ስራ' },
  'Textile Design': { en: 'Textile Design', am: 'የጨርቃጨርቅ ስራ' },
};

const AVAILABILITY_TRANSLATIONS = {
  'weekdays': { en: 'Weekdays', am: 'ከሰኞ እስከ አርብ' },
  'weekends': { en: 'Weekends', am: 'ቅዳሜ እና እሁድ' },
  'evenings': { en: 'Evenings', am: 'ማታ' },
  'emergency': { en: 'Emergency', am: 'አስቸኳይ' }
};

// Helper functions
export const getTranslatedCities = (language: string) => {
  return DB_CITIES.map(city => ({
    id: city,
    name: CITY_TRANSLATIONS[city][language] || city
  }));
};

export const getTranslatedServiceCategories = (language: string) => {
  return Object.entries(DB_SERVICES).map(([categoryId, services]) => {
    const categoryName = CATEGORY_TRANSLATIONS[categoryId][language] || categoryId;
    const translatedServices = services.map(service => ({
      id: service,
      name: SERVICE_TRANSLATIONS[service][language] || service
    }));

    return {
      categoryId: categoryId,
      categoryName: categoryName,
      services: translatedServices
    };
  });
};

export const getCityNameById = (id: string, language: string): string => {
  return CITY_TRANSLATIONS[id]?.[language] || id;
};

export const getServiceNameById = (id: string, language: string): string => {
  return SERVICE_TRANSLATIONS[id]?.[language] || id;
};

export const getAvailabilityName = (id: string, language: string): string => {
  return AVAILABILITY_TRANSLATIONS[id]?.[language] || id;
};

export const getItemCategoryName = (id: string, language: string): string => {
  return ITEM_CATEGORIES[id]?.[language] || id;
};

export const getItemConditionName = (id: string, language: string): string => {
  return ITEM_CONDITIONS[id]?.[language] || id;
};